const dollarUSLocale = Intl.NumberFormat('en-US');

export const formatMoney = (amount) => `$${dollarUSLocale.format(amount)}.00`;

export const capitalize = (text) => text[0].toUpperCase() + text.slice(1).toLowerCase();
